/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Signup_LinkInputs */

const en_auth_login_signup_link = /** @type {(inputs: Auth_Login_Signup_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create one, it's free`)
};

const pl_auth_login_signup_link = /** @type {(inputs: Auth_Login_Signup_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Załóż je, to nic nie kosztuje`)
};

/**
* | output |
* | --- |
* | "Create one, it's free" |
*
* @param {Auth_Login_Signup_LinkInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_login_signup_link = /** @type {((inputs?: Auth_Login_Signup_LinkInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Signup_LinkInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_login_signup_link(inputs)
	return en_auth_login_signup_link(inputs)
});